<script setup lang="ts">
  import SinaProLogo from '@assets/logo/sina-pro.svg'

  const { t } = useI18n()
  const { loading } = defineProps<{
    loading: boolean,
  }>()

  const emit = defineEmits<{
    'fetch-plans': [],
    'close': [],
  }>()

  const onFetchPlans = () => {
    emit('fetch-plans')
  }
  const onClose = () => {
    emit('close')
  }
</script>

<template>
  <v-row class="mx-auto mb-8" no-gutters>
    <v-spacer />

    <v-col align-self="center" class="mt-md-8 d-flex justify-center text-center text-grey-100">
      <sina-pro-logo
        height="90"
        width="90"
      />
    </v-col>

    <v-col class="d-flex justify-end">
      <v-btn
        color="grey-100"
        rounded="pill"
        size="38"
        slim
        variant="plain"
        @click="onClose"
      >
        <v-icon icon="mdi-close" size="24" />
      </v-btn>
    </v-col>
  </v-row>

  <v-row justify="center" no-gutters>
    <v-col
      class="text-center"
      cols="12"
      lg="8"
      md="10"
    >
      <div class="empty-state">
        <!-- Empty State Icon -->
        <div class="mb-6">
          <v-icon
            color="grey-400"
            icon="mdi-package-variant-closed"
            size="80"
          />
        </div>

        <!-- Empty State Title -->
        <h2 class="text-h5 font-weight-bold text-grey-100 mb-4">
          {{ t('subscription.no_plans_title', 'لا توجد خطط متاحة حالياً') }}
        </h2>

        <!-- Empty State Description -->
        <p class="text-body-1 text-grey-300 mb-8 px-4">
          {{
            t('subscription.no_plans_description', 'نعتذر، لا توجد خطط اشتراك متاحة في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً أو التواصل مع الدعم الفني.')
          }}
        </p>

        <!-- Action Buttons -->
        <div class="d-flex flex-column flex-sm-row gap-4 justify-center align-center">
          <v-btn
            color="primary"
            :loading="loading"
            rounded="lg"
            size="large"
            variant="flat"
            @click="onFetchPlans"
          >
            <v-icon icon="mdi-refresh" start />
            {{ t('subscription.retry_loading', 'إعادة المحاولة') }}
          </v-btn>

          <v-btn
            color="grey-300"
            rounded="lg"
            size="large"
            variant="outlined"
            @click=""
          >
            <v-icon icon="mdi-headset" start />
            {{ t('subscription.contact_support', 'تواصل مع الدعم') }}
          </v-btn>
        </div>

        <!-- Additional Help Text -->
        <div class="mt-8 pa-4 bg-grey-800 rounded-lg">
          <p class="text-caption text-grey-400 mb-2">
            <v-icon class="me-1" icon="mdi-information-outline" size="16" />
            {{ t('subscription.help_text', 'تحتاج مساعدة؟') }}
          </p>
          <p class="text-caption text-grey-300">
            {{
              t('subscription.help_description', 'يمكنك التواصل مع فريق الدعم الفني للحصول على المساعدة في اختيار الخطة المناسبة لك.')
            }}
          </p>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">

</style>
